import { render, staticRenderFns } from "./ComponentMatter.vue?vue&type=template&id=45676166"
import script from "./ComponentMatter.vue?vue&type=script&lang=js"
export * from "./ComponentMatter.vue?vue&type=script&lang=js"
import style0 from "./ComponentMatter.vue?vue&type=style&index=0&id=45676166&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports